import {
	createApp
} from 'vue';
import website from './config/website';
import axios from './axios';
import router from './router/';
import store from './store/';
import i18n from './lang/';
import {
	language,
	messages
} from './lang/';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
 import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import crudCommon from '@/mixins/crud.js';
import {
	getScreen
} from './utils/util';
import './permission';
import error from './error';
import avueUeditor from 'components/avue-ueditor/main.vue';
import basicBlock from 'components/basic-block/main.vue';
import basicContainer from 'components/basic-container/main.vue';
import thirdRegister from './components/third-register/main.vue';
import NfDesignBase from '@saber/nf-design-base-elp';
import flowDesign from './components/flow-design/main.vue';
import App from './App.vue';
import 'animate.css';
import dayjs from 'dayjs';
import 'styles/common.scss';


// 业务组件
import tenantPackage from './views/system/tenantpackage.vue';
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import ProLayout, { PageContainer } from "@ant-design-vue/pro-layout";
import "@ant-design-vue/pro-layout/dist/style.css";
//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';

import { Dialog } from 'vant';
import VmFormDesigner from '@/../lib/vformMobile3/designer.umd.js'
import '../lib/vformMobile3/designer.style.css'
import log from "app-lib-log"
import PortalVue from 'portal-vue'
import { createPinia } from 'pinia';
import VueClipboard from 'vue3-clipboard';
import Print from 'vue3-print-nb'



log.setOption({level:0});

// import EZUIKit from '@/../lib/ezuikit/ezuikit.js'


window.$crudCommon = crudCommon;
window.axios = axios;
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}

// 全局注册
app.use(Dialog);
app.use(PortalVue)
app.use(createPinia())

app.component('ProLayout', ProLayout)
app.component('PageContainer', PageContainer)
// app.component('PageHeaderWrapper', PageHeaderWrapper)



app.component('avueUeditor', avueUeditor);
app.component('basicContainer', basicContainer);
app.component('basicBlock', basicBlock);
app.component('thirdRegister', thirdRegister);
app.component('flowDesign', flowDesign);
app.component('tenantPackage', tenantPackage);
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.website = website;
app.config.globalProperties.getScreen = getScreen;

app.use(error);
app.use(Vant) //全局注册vamt
app.use(VmFormDesigner);
// app.use(EZUIKit);
app.use(i18n);

app.use(router);
app.use(store);

app.use(VueClipboard, {
	autoSetContainer: true,
	appendToBody: true, // 这可以帮助解决一些更复杂的使用场景下的问题
})

app.use(Print)

app.use(Antd);
app.use(ElementPlus, {
	locale: messages[language],
});
app.use(Avue, {
	axios,
	calcHeight: 10,
	locale: messages[language],
});
app.use(NfDesignBase);
app.mount('#app');
